module.exports = __webpack_public_path__ + "img/image22.09c2a902.png";